import { render, staticRenderFns } from "./Scb.vue?vue&type=template&id=d96533f0&scoped=true&"
var script = {}
import style0 from "./Scb.vue?vue&type=style&index=0&id=d96533f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96533f0",
  null
  
)

export default component.exports